import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Link, useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Button } from '@mui/material';

import { IUser } from '../../../app/interfaces/user';
import { useDefineUserRole } from '../../../app/hooks';

const useStyles = makeStyles()(theme => {
  return {
    menuContainer: {
      display: 'block',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    menu: {
      width: 25,
      height: 20,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    topbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      width: 'calc(100%)',
      gap: 50,
    },
    toggler: {
      height: 3,
      borderRadius: 3,
      width: '100%',
      backgroundColor: '#cecece',
    },
    title: {
      margin: 0,
      fontWeight: 'bold',
      fontSize: 15,
      padding: '5px 10px',
      backgroundColor: '#eaeaea',
      borderRadius: 5,
    },
    containerBtns: {
      display: 'flex',
      gap: 15,
    },
    btn: {
      flex: 1,
      height: 44,
      textTransform: 'inherit',
      fontSize: 14,
      color: '#fff',
      backgroundColor: '#7c97c0',
      textWrap: 'nowrap',
      borderRadius: 22,
      '&:hover': {
        backgroundColor: '#7c97c0',
        opacity: 0.9,
      },
    },
  };
});

type TProps = {
  me?: IUser;
  showBurger?: boolean;
  isAuthorized?: boolean;
};

const Topbar: React.FC<TProps> = ({ me, showBurger, isAuthorized }) => {
  const { classes } = useStyles();
  const intl = useIntl();
  const navigate = useNavigate();

  const handleClickBecomeBtn = (role: 'ROLE_BUYER' | 'ROLE_VENDOR') => {
    localStorage.setItem('alignment', role);
    localStorage.setItem('authTab', '1');
    navigate('/auth/main');
  };

  const isBuyer = useDefineUserRole(me, ['ROLE_BUYER', 'ROLE_BUYER_STAFF']);
  return (
    <div className={`kt-header__topbar ${classes.topbar}`}>
      <div className={classes.menuContainer}>
        {showBurger ? (
          <div id='kt_header_mobile_toggler' className={classes.menu}>
            <span className={classes.toggler} />
            <span className={classes.toggler} />
            <span className={classes.toggler} />
          </div>
        ) : (
          <Link to={'/products/catalog'}>
            <p className={classes.title}>
              {intl.formatMessage({ id: 'MENU.PRODUCTS.CATALOG' })}
            </p>
          </Link>
        )}
      </div>

      {!isAuthorized ? (
        <div className={classes.containerBtns}>
          <Button
            onClick={() => handleClickBecomeBtn('ROLE_BUYER')}
            className={classes.btn}
            variant='contained'
          >
            {intl.formatMessage({
              id: 'AUTH.BUTTON.REGISTER',
            })}
          </Button>
        </div>
      ) : null}

    </div>
  );
};

export default Topbar;
